// extracted by mini-css-extract-plugin
export default {"upload":"a1x7F","uploadBlock":"KjZxC","uploadTitle":"m7pXA","uploadText":"BDQbC","uploadOr":"IlRCv","progress":"CFtvV","bar":"Mwsgl","btn":"UGwJW"};